export var IconCategory;
(function (IconCategory) {
    IconCategory["Arrow"] = "arrow";
    IconCategory["Attention"] = "attention";
    IconCategory["Basic"] = "basic";
    IconCategory["Brand"] = "brand";
    IconCategory["Calendar"] = "calendar";
    IconCategory["Chart"] = "chart";
    IconCategory["Communication"] = "communication";
    IconCategory["Device"] = "device";
    IconCategory["Edit"] = "edit";
    IconCategory["Experimental"] = "experimental";
    IconCategory["File"] = "file";
    IconCategory["Grid"] = "grid";
    IconCategory["Home"] = "home";
    IconCategory["Media"] = "media";
    IconCategory["Menu"] = "menu";
    IconCategory["Misc"] = "misc";
    IconCategory["Notification"] = "notification";
    IconCategory["System"] = "system";
    IconCategory["User"] = "user";
})(IconCategory || (IconCategory = {}));
//# sourceMappingURL=icons.types.js.map